import * as model from "@/model/prd/shiftHandOver/ShiftHandOver";
import { newEntityStoreHelper } from "@/store/common/entityModule";

//import router from "@/router/index";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter);
    return filter;
}

export default newEntityStoreHelper(() => new model.ShiftHandOver(), newFilter)
    .withStates({
        idReport: 2,
        locations: [],
        users: [],
        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
    })
    .withActions({
        loadLocations(context) {
           context.dispatch("api/get", {
                   url: process.env.VUE_APP_MASTER_API_URL + "master-service/master" + "/location/findAll"
               }, { root: true })
               .then(function(data) {
                   context.commit("setLocations", data);
               })
       },

       loadUsers(context) {
        context.dispatch("api/get", {
                url: process.env.VUE_APP_ADM_API_URL + "adm-service/adm" + "/user/findAll"
            }, { root: true })
            .then(function(data) {
                context.commit("setUsers", data);
            })
    },

       affirmShiftHandover(context, entity) {
        //router.push("/prd/shiftHandover");
        context.dispatch("api/get", {
            url: context.state.baseModuleUrl + "/shiftHandOver/affirmShiftHandover/" + entity.id
        },{ root: true })
        .then(response => {
            //seting the values
            {
                context.commit('shiftHandOver' + "/setRows", [response], { root: true });
            }
        });
    },
   })
   .withMutations({
        setLocations(state, locations) {
            state.locations = locations;
        },
        setUsers(state, users) {
            state.users = users;
        }
    })
    .buildStore()
